"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureEnd = void 0;
const Note_1 = require("../Note");
const NoteType_1 = require("../lib/NoteType");
/**
 * Represents the end of a measure. Must always be the very last item in a note
 * sequence. Represented by comma (`,`).
 */
class MeasureEnd extends Note_1.Note {
    constructor() {
        super(NoteType_1.NoteType.MeasureEnd);
    }
}
exports.MeasureEnd = MeasureEnd;
